module.exports = __webpack_public_path__ + "static/media/team2.feb079e4.jpg";